import { takeLatest } from "redux-saga/effects";
import { getMobileFrameData } from "../store/mobile-frame-home-page.store";
import {
  assistanceDataSaga,
  blocksSoundsDataSaga,
  eventStatusListDataSaga,
  mobileFrameDataSaga,
  setActionEventSaga,
  setBlocksSoundsLevelSaga,
  stopAllActionEventSaga,
  calendarEventDataSaga,
  deleteCalendarEventDataSaga,
  addCalendarEventDataSaga,
  setEklokLineStatusSaga,
} from "./mobile-frame.saga";
import { getCommandListPageData } from "../store/command-list-page.store";
import {
  getCommandDetailPageData,
  getEventStatusListData,
  sendCommand,
} from "../store/command-detail-page.store";
import {
  getEventStatusListPageData,
  stopAction,
  stopAllAction,
} from "../store/event-status-list-page.store";
import {
  getBlocksSoundsData,
  setBlocksSoundsLevel,
} from "../store/blocks-sounds-page.store";
import { getAssistanceData } from "../store/assistance-page.store";
import {
  getCalendarEventData,
  deleteCalendarEventData,
} from "../store/calendar-event-page.store";
import { addCalendarEventData } from "../store/add-calendar-event-page.store";
import { initConnectionLineStatus } from "../store/eklok-line-status.store";

function* sagas() {
  yield takeLatest(getMobileFrameData.type, mobileFrameDataSaga);
  yield takeLatest(getCommandListPageData.type, mobileFrameDataSaga);
  yield takeLatest(getCommandDetailPageData.type, mobileFrameDataSaga);
  yield takeLatest(getEventStatusListData.type, eventStatusListDataSaga);
  yield takeLatest(getEventStatusListPageData.type, eventStatusListDataSaga);
  yield takeLatest(stopAllAction.type, stopAllActionEventSaga);
  yield takeLatest(stopAction.type, setActionEventSaga);
  yield takeLatest(sendCommand.type, setActionEventSaga);
  yield takeLatest(getBlocksSoundsData.type, blocksSoundsDataSaga);
  yield takeLatest(setBlocksSoundsLevel.type, setBlocksSoundsLevelSaga);
  yield takeLatest(getAssistanceData.type, assistanceDataSaga);
  yield takeLatest(getCalendarEventData.type, calendarEventDataSaga);
  yield takeLatest(deleteCalendarEventData.type, deleteCalendarEventDataSaga);
  yield takeLatest(addCalendarEventData.type, addCalendarEventDataSaga);
  yield takeLatest(initConnectionLineStatus.type, setEklokLineStatusSaga);
}

export default sagas;
